import React from "react";
import { BrowserRouter} from "react-router-dom";
 import Chat1 from "./Chat/Chat1";



export default function App() {
  return (
    <BrowserRouter>
     <Chat1/>
    </BrowserRouter>
  );
}
